
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { setResultModalData, showModal } from "../modal/modalSlice";
import axiosInstance from "../../axios/axiosInstance";

const initialState = {

    isLoadingGetKiralikAracArayanlar: false,

    kiralikAracArayanFirmalarList: [],
    kiralikAracFirmaCount: null,

    rentalCarList: [],

    jobSeekerList:[],

    driverSeekerList: [],
    driverSeekerCount: 0,

    saleVehicleList: [],
    saleVehicleCount: 0,

    selectRentalCar: null,
    selectedAdvert: null,

    isLoadingGetRental: false,
    isLoadingErrorGetRental: false,
    isLoadingAddRental: false,
    isLoadingErrorAddRental: false,
    isLoadingDeleteRental: false,
    isLoadingErrorDeleteRental: false,
    isLoadingUpdateRental: false,
    isLoadingErrorUpdateRental: false,

}
//! kiralık araç arayan firmalar get
export const getKiralikAracArayanFirmalar = createAsyncThunk("ilanlar/getKiralikAracArayanFirmalar", async({ workCity="", vehicleType="", isAdvertiserCompany, page}, thunkApi)=> {
    try {
        
        const {data} = await axiosInstance.get(`/Adverts/GetAllRentVehicle?vehicleType=${vehicleType}&workCity=${workCity}&isAdvertiserCompany=${isAdvertiserCompany}&page=${page}`)
        
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

//! kiralık araç arayan firmalar ekleme

export const addRentalCarSeekers = createAsyncThunk("ilanlar/addRentalCarSeekers", async(body, thunkApi)=> {
    try {
        const {data} = await axiosInstance.post(`/Adverts/CreateRentVehicle`, body)
        if (data) {
            thunkApi.dispatch(showModal("result"));
            thunkApi.dispatch(
              setResultModalData({
                msg: "Başarılı Bir Şekilde Eklendi. Onaylanınca Listede Yayınlanacak.",
                resultType: "success",
                btnText1: "Listeyi Görüntüle",
              })
            );
        }
        
        return data.data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})
//! kiralık araç arayan firmalar silme
export const deleteRentalCarSeekers = createAsyncThunk("ilanlar/deleteRentalCarSeekers", async(body, thunkApi)=> {
    try {
        const {data} = await axiosInstance.post(`/Adverts/DeleteRentVehicle`, body)
        
        if (data.statusCode === 200) {
            thunkApi.dispatch(showModal("result"));
            thunkApi.dispatch(
              setResultModalData({
                msg: "Başarılı Bir Silindi Eklendi.",
                resultType: "success",
                btnText1: "Listeyi Görüntüle",
              })
            );
        }
        
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

//! kiralık araç arayan firmalar silme
export const updateRentalCarSeekers = createAsyncThunk("ilanlar/updateRentalCarSeekers", async(body, thunkApi)=> {
    try {
        const {data} = await axiosInstance.post(`/Adverts/UpdateRentVehicle`, body)
        if (data) {
            thunkApi.dispatch(showModal("result"));
            thunkApi.dispatch(
              setResultModalData({
                msg: "Başarılı Bir Şekilde Güncellendi.",
                resultType: "success",
                btnText1: "Listeyi Görüntüle",
              })
            );
        }
        
        return data.data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

//! kiralık araç ekleme
export const addRentalCar = createAsyncThunk("ilanlar/addRentalCar", async(body, thunkApi)=> {
    try {
        const {data} = await axiosInstance.post(`/Adverts/CreateTruckVehicle`, body)
        if (data) {
            thunkApi.dispatch(showModal("result"));
            thunkApi.dispatch(
              setResultModalData({
                msg: "Başarılı Bir Şekilde Eklendi. Onaylanınca Listede Yayınlanacak.",
                resultType: "success",
                btnText1: "Listeyi Görüntüle",
              })
            );
        }
        
        return data.data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})
//! kiralık araç get
export const getRentalCar = createAsyncThunk("ilanlar/getRentalCar", async({workCity = "", vehicleType = "", isAdvertiserUser, page}, thunkApi)=> {
    try {
        const {data} = await axiosInstance.get(`/Adverts/GetAllTruckVehicle?workCity=${workCity}&vehicleType=${vehicleType}&isAdvertiserUser=${isAdvertiserUser}&page=${page}`)
        
        return data.data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})
//! kiralık araç delete
export const deleteRentalCar = createAsyncThunk("ilanlar/deleteRentalCar", async(body, thunkApi)=> {
    try {
        const {data} = await axiosInstance.post(`/Adverts/DeleteTruckVehicle`, body)
        
        if (data) {
            thunkApi.dispatch(showModal("result"));
            thunkApi.dispatch(
              setResultModalData({
                msg: "Başarılı Bir Şekilde Silindi.",
                resultType: "success",
                btnText1: "Listeyi Görüntüle",
              })
            );
        }
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})
//! kiralık araç update
export const updateRentalCar = createAsyncThunk("ilanlar/updateRentalCar", async(body, thunkApi)=> {
    try {
        const {data} = await axiosInstance.post(`/Adverts/UpdateTruckVehicle`, body)
        if (data) {
            thunkApi.dispatch(showModal("result"));
            thunkApi.dispatch(
              setResultModalData({
                msg: "Başarılı Bir Şekilde Güncellendi.",
                resultType: "success",
                btnText1: "Listeyi Görüntüle",
              })
            );
        }
        return data.data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

//! iş arayan sürücüler 
export const getAllJobSeekerAdvert = createAsyncThunk("ilanlar/getAllJobSeekerAdvert", async({workCity = "", page}, thunkApi)=> {
    try {
        const {data} = await axiosInstance.get(`/Adverts/GetAllDriverJobSeeker?workCity=${workCity}&page=${page}`)
        
        return data.data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

//! sürücü arayan ekle
export const addDriverSeeker = createAsyncThunk("ilanlar/addDriverSeeker", async(body, thunkApi)=> {
    try {  
        const {data} = await axiosInstance.post(`/Adverts/CreateDriverSeeker`, body)
        if (data) {
            thunkApi.dispatch(showModal("result"));
            thunkApi.dispatch(
              setResultModalData({
                msg: "Başarılı Bir Şekilde Eklendi. Onaylanınca Listede Yayınlanacak.",
                resultType: "success",
                btnText1: "Listeyi Görüntüle",
              })
            );
        }
        return data.data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

//! sürücü arayan get
export const getDriverSeeker = createAsyncThunk("ilanlar/getDriverSeeker", async( {workCity = "", page}, thunkApi)=> {
    try {  
        
        const {data} = await axiosInstance.get(`/Adverts/GetAllDriverSeeker?workCity=${workCity}&page=${page}`,)
        
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

//! sürücü arayan delete
export const deleteDriverSeeker = createAsyncThunk("ilanlar/deleteDriverSeeker", async(body, thunkApi)=> {
    try {  
        const {data} = await axiosInstance.post(`/Adverts/DeleteDriverSeeker`, body)
        
        if (data.statusCode === 200) {
            thunkApi.dispatch(showModal("result"));
            thunkApi.dispatch(
              setResultModalData({
                msg: "Başarılı Bir Şekilde Silindi.",
                resultType: "success",
                btnText1: "Listeyi Görüntüle",
              })
            );
        }
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

//! sürücü arayan delete
export const updateDriverSeeker = createAsyncThunk("ilanlar/updateDriverSeeker", async(body, thunkApi)=> {
    try {  
        const {data} = await axiosInstance.post(`/Adverts/UpdateDriverSeeker`, body)
        if (data) {
            thunkApi.dispatch(showModal("result"));
            thunkApi.dispatch(
              setResultModalData({
                msg: "Başarılı Bir Şekilde Güncellendi.",
                resultType: "success",
                btnText1: "Listeyi Görüntüle",
              })
            );
        }
        return data.data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

//! satılık araç get

export const getAllSaleVehicle = createAsyncThunk("ilanlar/getAllSaleVehicle", async({page}, thunkApi)=> {
    try {  
        const {data} = await axiosInstance.get(`/TruckTrailer/GetAllSaleVehicle?page=${page}`,)
        
        return data.data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})
//! satılık araç add
export const addSaleVehicle = createAsyncThunk("ilanlar/addSaleVehicle", async(body, thunkApi)=> {
    try {  
        const file = new FormData();
        file.append("vehicleType", body.vehicleType)
        file.append("model", body.model)
        file.append("km", body.km)
        file.append("price", body.price)
        file.append("description", body.description)
        file.append("advertStatus", body.advertStatus)
        body.files.forEach((fileItem, index) => {
            const newIndex = index + 1
            file.append(`photo${newIndex}`, fileItem?.selectedFile);
        });
        
        const {data} = await axiosInstance.post(`/TruckTrailer/AddSaleVehicle`, file)
        if (data) {
            thunkApi.dispatch(showModal("result"));
            thunkApi.dispatch(
              setResultModalData({
                msg: "Başarılı Bir Şekilde Eklendi.",
                resultType: "success",
                btnText1: "Listeyi Görüntüle",
              })
            );
        }
        return data.data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

//! satılık araç güncelle
export const updateSaleVehicle = createAsyncThunk("ilanlar/updateSaleVehicle", async(body, thunkApi)=> {
    try {  
        const file = new FormData();
        file.append("vehicleType", body.vehicleType)
        file.append("model", body.model)
        file.append("km", body.km)
        file.append("price", body.price)
        file.append("description", body.description)
        file.append("advertStatus", body.advertStatus)
        file.append("isVehicleSale", body.isVehicleSale)
        file.append("id", body.id)
        body.files.forEach((fileItem, index) => {
            if (fileItem?.doc !== undefined) {
                const newIndex = index + 1;
                file.append(`photo${newIndex}`, fileItem?.doc);
            }
        });
        const {data} = await axiosInstance.post(`/TruckTrailer/UpdateSaleVehicle`, file)
        if (data) {
            thunkApi.dispatch(showModal("result"));
            thunkApi.dispatch(
              setResultModalData({
                msg: "Başarılı Bir Şekilde Güncellendi.",
                resultType: "success",
                btnText1: "Listeyi Görüntüle",
              })
            );
        }
        return data.data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

//! satılık araç sil
export const deleteSaleVehicle = createAsyncThunk("ilanlar/deleteSaleVehicle", async(body, thunkApi)=> {
    try {  
        const {data} = await axiosInstance.post(`/TruckTrailer/DeleteSaleVehicle`,body)
        
        if (data) {
            thunkApi.dispatch(showModal("result"));
            thunkApi.dispatch(
              setResultModalData({
                msg: "Başarılı Bir Şekilde Silindi.",
                resultType: "success",
                btnText1: "Listeyi Görüntüle",
              })
            );
        }
        return data.data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})


const ilanlarSlice = createSlice({
    name: "ilanlar",
    initialState,
    reducers: {
        setSelectRentalCar: (state, action) => {
            state.selectRentalCar = action.payload
        },

        setSelectedAdvertiser: (state, action) => {
            state.selectedAdvert = action.payload
        }
    },
    extraReducers:(builder)=> {
        builder
        
        //!
        .addCase(getKiralikAracArayanFirmalar.pending, (state)=> {
            state.isLoadingGetKiralikAracArayanlar = true
        })
        .addCase(getKiralikAracArayanFirmalar.fulfilled, (state, action)=> {
            state.isLoadingGetKiralikAracArayanlar = false
            state.kiralikAracArayanFirmalarList = action.payload.data.items.$values
            state.kiralikAracFirmaCount = parseInt(action.payload.message)
            
        })
        .addCase(getKiralikAracArayanFirmalar.rejected, (state, action)=> {
            state.isLoadingGetKiralikAracArayanlar = false
        })

        //!
        .addCase(addRentalCarSeekers.pending, (state)=> {
            state.isLoadingAddRental = true
        })
        .addCase(addRentalCarSeekers.fulfilled, (state, action)=> {
            state.isLoadingAddRental = false
            state.kiralikAracArayanFirmalarList = [...state.kiralikAracArayanFirmalarList, action.payload]
        })
        .addCase(addRentalCarSeekers.rejected, (state, action)=> {
            state.isLoadingAddRental = false
        })
        //!
        .addCase(deleteRentalCarSeekers.pending, (state)=> {
            state.isLoadingAddRental = true
        })
        .addCase(deleteRentalCarSeekers.fulfilled, (state, action)=> {
            state.isLoadingAddRental = false
            state.kiralikAracArayanFirmalarList = state.kiralikAracArayanFirmalarList.filter((item) => {
                return item?.id !== action.payload.data.id
            })
        })
        .addCase(deleteRentalCarSeekers.rejected, (state, action)=> {
            state.isLoadingAddRental = false
        })

        //!
        .addCase(updateRentalCarSeekers.pending, (state)=> {
            state.isLoadingAddRental = true
        })
        .addCase(updateRentalCarSeekers.fulfilled, (state, action)=> {
            state.isLoadingAddRental = false
            state.kiralikAracArayanFirmalarList = state.kiralikAracArayanFirmalarList.map((item) => {
                if(item?.id === action.payload.id){
                    return action.payload
                }else{
                    return item
                }
            })
        })
        .addCase(updateRentalCarSeekers.rejected, (state, action)=> {
            state.isLoadingAddRental = false
        })
        
        
        //!
        .addCase(addRentalCar.pending, (state)=> {
            state.isLoadingAddRental = true
        })
        .addCase(addRentalCar.fulfilled, (state, action)=> {
            state.isLoadingAddRental = false
            state.rentalCarList = [...state.rentalCarList, action.payload]
        })
        .addCase(addRentalCar.rejected, (state, action)=> {
            state.isLoadingErrorAddRental = true
        })

        //!
        .addCase(getRentalCar.pending, (state)=> {
            state.isLoadingGetRental = true
        })
        .addCase(getRentalCar.fulfilled, (state, action)=> {
            state.isLoadingGetRental = false
            state.rentalCarList = action.payload.items.$values
        })
        .addCase(getRentalCar.rejected, (state, action)=> {
            state.isLoadingGetRental = true
            state.isLoadingErrorGetRental = false
        })

        //!
        .addCase(deleteRentalCar.pending, (state)=> {
            state.isLoadingDeleteRental = true
        })
        .addCase(deleteRentalCar.fulfilled, (state, action)=> {
            state.isLoadingDeleteRental = false
            state.rentalCarList = state.rentalCarList.filter((item) => {
                return item?.id !== action.payload.data.id
            })
        })
        .addCase(deleteRentalCar.rejected, (state, action)=> {
            state.isLoadingDeleteRental = true
            state.isLoadingErrorDeleteRental = false
        })

        //!
        .addCase(updateRentalCar.pending, (state)=> {
            state.isLoadingUpdateRental = true
        })
        .addCase(updateRentalCar.fulfilled, (state, action)=> {
            state.isLoadingUpdateRental = false
            state.rentalCarList = state.rentalCarList.map((item) => {
                if(item?.id === action.payload.id){
                    return action.payload
                }else{
                    return item
                }
            })
        })
        .addCase(updateRentalCar.rejected, (state, action)=> {
            state.isLoadingUpdateRental = true
            state.isLoadingErrorUpdateRental = false
        })

        //!
        .addCase(getAllJobSeekerAdvert.pending, (state)=> {
            state.isLoadingGetRental = true
        })
        .addCase(getAllJobSeekerAdvert.fulfilled, (state, action)=> {
            state.isLoadingGetRental = false
            state.jobSeekerList = action.payload.items
        })
        .addCase(getAllJobSeekerAdvert.rejected, (state, action)=> {
            state.isLoadingGetRental = true
            state.isLoadingErrorGetRental = false
        })
        

        //!
        .addCase(addDriverSeeker.pending, (state)=> {
            state.isLoadingAddRental = true
        })
        .addCase(addDriverSeeker.fulfilled, (state, action)=> {
            state.isLoadingAddRental = false
            state.driverSeekerList = [...state.driverSeekerList, action.payload]
        })
        .addCase(addDriverSeeker.rejected, (state, action)=> {
            state.isLoadingErrorAddRental = true
        })

        
        //!
        .addCase(getDriverSeeker.pending, (state)=> {
            state.isLoadingGetRental = true
        })
        .addCase(getDriverSeeker.fulfilled, (state, action)=> {
            state.isLoadingGetRental = false
            state.driverSeekerList = action.payload.data.items.$values
            state.driverSeekerCount = action.payload.data.count
        })
        .addCase(getDriverSeeker.rejected, (state, action)=> {
            state.isLoadingGetRental = true
            state.isLoadingErrorGetRental = false
        })

        //!
        .addCase(deleteDriverSeeker.pending, (state)=> {
            state.isLoadingDeleteRental = true
        })
        .addCase(deleteDriverSeeker.fulfilled, (state, action)=> {
            state.isLoadingDeleteRental = false
            state.driverSeekerList = state.driverSeekerList.filter((item) => {
                return item?.id !== action.payload.data.id
            })
        })
        .addCase(deleteDriverSeeker.rejected, (state, action)=> {
            state.isLoadingDeleteRental = true
            state.isLoadingErrorDeleteRental = false
        })

        
        //!
        .addCase(updateDriverSeeker.pending, (state)=> {
            state.isLoadingUpdateRental = true
        })
        .addCase(updateDriverSeeker.fulfilled, (state, action)=> {
            state.isLoadingUpdateRental = false
            state.driverSeekerList = state.driverSeekerList.map((item) => {
                if(item?.id === action.payload.id){
                    return action.payload
                }else{
                    return item
                }
            })
        })
        .addCase(updateDriverSeeker.rejected, (state, action)=> {
            state.isLoadingUpdateRental = true
            state.isLoadingErrorUpdateRental = false
        })

        //!
        .addCase(getAllSaleVehicle.pending, (state)=> {
            state.isLoadingGetRental = true
        })
        .addCase(getAllSaleVehicle.fulfilled, (state, action)=> {
            state.isLoadingGetRental = false
            state.saleVehicleList = action.payload.$values
            state.saleVehicleCount = action.payload.$values
            
        })
        .addCase(getAllSaleVehicle.rejected, (state, action)=> {
            state.isLoadingGetRental = true
            state.isLoadingErrorGetRental = false
        })

        
       //!
       .addCase(addSaleVehicle.pending, (state)=> {
        state.isLoadingAddRental = true
        })
        .addCase(addSaleVehicle.fulfilled, (state, action)=> {
            state.isLoadingAddRental = false
            state.saleVehicleList = [...state.saleVehicleList, action.payload]
        })
        .addCase(addSaleVehicle.rejected, (state, action)=> {
            state.isLoadingErrorAddRental = true
        })

        //!
        .addCase(deleteSaleVehicle.pending, (state)=> {
            state.isLoadingDeleteRental = true
        })
        .addCase(deleteSaleVehicle.fulfilled, (state, action)=> {
            state.isLoadingDeleteRental = false
            state.saleVehicleList = state.saleVehicleList.filter((item) => {
                return item?.id !== action.payload?.id
            })
        })
        .addCase(deleteSaleVehicle.rejected, (state, action)=> {
            state.isLoadingDeleteRental = true
            state.isLoadingErrorDeleteRental = false
        })
        
        //!
        .addCase(updateSaleVehicle.pending, (state)=> {
            state.isLoadingUpdateRental = true
        })
        .addCase(updateSaleVehicle.fulfilled, (state, action)=> {
            state.isLoadingUpdateRental = false
            state.saleVehicleList = state.saleVehicleList.map((item) => {
                if(item?.id === action.payload.id){
                    return action.payload
                }else{
                    return item
                }
            })
        })
        .addCase(updateSaleVehicle.rejected, (state, action)=> {
            state.isLoadingUpdateRental = true
            state.isLoadingErrorUpdateRental = false
        })
        
    }
})


export const {setSelectRentalCar, setSelectedAdvertiser} = ilanlarSlice.actions
export default ilanlarSlice.reducer